import { type ComponentProps, memo } from 'react';
import { useResizeDetector } from 'react-resize-detector';

import { formatDuration } from '@air/utilities';
import { cn } from '@air/utils-tailwind';

import { usePlayerStore } from './PlayerContextProvider';

export type PlayerTimeFormatStandardProps = ComponentProps<'div'> & {
  duration?: number;
};

export const PlayerTimeFormatStandard = memo(
  ({ className, duration: durationProp, ...restOfProps }: PlayerTimeFormatStandardProps) => {
    const currentTime = usePlayerStore((state) => state.currentTime);
    const duration = usePlayerStore((state) => state.duration);
    const { ref: resizeRef, width } = useResizeDetector({
      handleHeight: false,
    });

    return (
      <div
        className={cn('flex gap-1 tabular-nums', className)}
        data-testid="PLAYER_TIME_FORMAT_STANDARD"
        {...restOfProps}
      >
        <span
          className="text-right text-grey-12"
          data-testid="PLAYER_TIME_FORMAT_STANDARD_CURRENT"
          style={{
            // We set the min-width here to the width of the left element to prevent the left element from shifting.
            minWidth: width,
          }}
        >
          {formatDuration(currentTime)}
        </span>
        <span className="text-grey-9" data-testid="PLAYER_TIME_FORMAT_STANDARD_SEPARATOR">
          /
        </span>
        <span className="text-grey-9" data-testid="PLAYER_TIME_FORMAT_STANDARD_TOTAL" ref={resizeRef}>
          {duration ? formatDuration(duration) : durationProp ? formatDuration(durationProp) : '-'}
        </span>
      </div>
    );
  },
);

PlayerTimeFormatStandard.displayName = 'PlayerTimeFormatStandard';
